import React from 'react';
import { ITableColumns } from 'models/table';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { StyledIconWrapper, StyledRedButton, StyledBlueButton } from './styles';

export const documentsTableColumns = (): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f511',
    key: '',
    title: '',
    width: '48px',
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) =>
      props.completed ? (
        <StyledIconWrapper>
          <Icon type={EIconTypes.checkmark} color={colors.success800} fontSize={16} />
        </StyledIconWrapper>
      ) : (
        ''
      ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'name',
    title: 'Document Name',
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'filenames',
    title: 'File Name',
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f514',
    key: 'date',
    title: 'Upload Date',
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304b6f32f515',
    key: '',
    width: '100px',
    align: 'center',
    title: 'Actions',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <div>
        {props.completed ? (
          <Grid item spacing={1}>
            <Button
              variant={EButtonVariants.outlined}
              tableButton
              icon={EIconTypes.edit}
              onClick={() => {}}
            />
            <StyledRedButton
              variant={EButtonVariants.contained}
              tableButton
              icon={EIconTypes.delete}
              onClick={() => {}}
            />
          </Grid>
        ) : (
          <StyledBlueButton
            variant={EButtonVariants.contained}
            tableButton
            icon={EIconTypes.upload}
            onClick={() => {}}
          />
        )}
      </div>
    ),
  },
];
